import { createContext, useContext, useEffect, useState } from 'react';
import { usePocket } from './PocketContext';
import { OperatorsResponse } from '@/types/pocketbase-types';

interface AuthContextType {
    user: OperatorsResponse | null;
    isLoading: boolean;
}

const AuthContext = createContext<AuthContextType>({
    user: null,
    isLoading: true,
});

export function AuthProvider({ children }: { children: React.ReactNode }) {
    const { pb } = usePocket();
    const [user, setUser] = useState<OperatorsResponse | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Проверяем авторизацию при загрузке
        const authData = pb.authStore.model;
        if (authData) {
            setUser(authData as OperatorsResponse);
        }
        setIsLoading(false);

        // Подписываемся на изменения авторизации
        pb.authStore.onChange((token, model) => {
            setUser(model as OperatorsResponse | null);
            setIsLoading(false);
        });
    }, [pb]);

    return (
        <AuthContext.Provider value={{ user, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
} 